/*LIBRARY*/
import React, { useState, useEffect, useRef, useCallback } from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/
import { set_value_properties } from "../../App/actions/propertiesActions";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/
const WAIT_INTERVAL = 1_000;

const EDIT_LAYER_STYLE_1 = ({ auth, properties, set_value_properties }) => {
  //local state
  const [search_query, set_search_query] = useState("");
  const timerRef = useRef(null);

  useEffect(() => {
    // Cleanup timer on unmount
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  const on_reset_field = useCallback(() => {
    set_value_properties({
      key: "style_parameter",
      value: {
        paint_object: {},
        key: "",
        field_key: "",
        case_recomendation: "",
        color_logic: "",
        color_mode: "",
        value_array: [],
        type_of_object: {},
        type_of_array: [],
        min: 0,
        max: 0,
        steps: 5,
        is_number_count: [],
        constant_color: "#a0d062",
        style_type: "",
        is_cluster: false,
      },
    });
    set_value_properties({
      key: "layer_style_step",
      value: 1,
    });
  }, [set_value_properties]);

  const on_reset = () => {
    on_reset_field();
    set_search_query("");
  };

  const trigger_action = useCallback(
    (query) => {
      on_reset_field();
      if (query.length >= 2) {
        const { fields_edit_style } = properties;
        // Create regex to match entire query or any part of the query
        const regexString = query
          .split(" ")
          .map((word) => `(?=.*?${word})`)
          .join("|"); // Join with OR condition to match any part of the search_query
        const regex = new RegExp(regexString, "i");
        const list = fields_edit_style.filter((item) => regex.test(item.name));
        set_value_properties({
          key: "fields_edit_style_filtered",
          value: list,
        });
      }
    },
    [on_reset_field, properties, set_value_properties],
  );

  const on_change = (e) => {
    if (timerRef.current) clearTimeout(timerRef.current);
    const { name, value } = e.target;

    if (name === "search_query") {
      set_search_query(value);
      if (value === "") {
        on_reset_field();
      }
      timerRef.current = setTimeout(() => trigger_action(value), WAIT_INTERVAL);
    }
  };

  const on_next_step = () => {
    set_value_properties({
      key: "layer_style_step",
      value: 2,
    });
  };

  const on_click_field = (field) => {
    if (field.key && field.name) {
      const style_parameter = { ...field };
      delete style_parameter.key;
      set_value_properties({
        key: "style_parameter",
        value: style_parameter,
      });
      set_search_query(field.name);
    }
    on_next_step();
  };

  //local storage
  const language = localStorage?.language || auth.language;

  //global props
  const {
    fields_edit_style,
    fields_edit_style_filtered,
    layer_style_step,
    style_parameter,
  } = properties;

  //content
  let list_used = [];
  if (!search_query) {
    list_used = fields_edit_style;
  } else {
    list_used = fields_edit_style_filtered;
  }

  let search_result;
  if (
    search_query &&
    fields_edit_style_filtered?.length === 0 &&
    layer_style_step === 0
  ) {
    search_result = <p>{dict?.["No result"]?.[language]}</p>;
  } else if (!style_parameter.field_key) {
    search_result = (
      <section
        style={{
          maxHeight: "300px",
          overflowY: "scroll",
          overflowX: "hidden",
        }}
        className="margin_top"
      >
        {list_used.map((field, idx) => {
          const { name } = field;
          return (
            <div
              key={idx}
              className="cursor_pointer margin_bottom"
              onClick={() => on_click_field(field)}
              data-mapid={`listFilter-${idx}`}
            >
              <p
                style={{
                  maxHeight: "2em",
                  overflowY: "hidden",
                  padding: "5px",
                  wordBreak: "break-all",
                  borderRadius: "5px",
                }}
                className="text_medium background_grey_light"
              >
                {name}
              </p>
            </div>
          );
        })}
      </section>
    );
  }

  return (
    <main className="container_light margin_bottom outline_black">
      <h1 className="text_bold margin_bottom">
        {dict?.["Select column:"]?.[language]}
      </h1>
      {style_parameter.key ? (
        <>
          <p className="badge_small background_black">
            {dict?.["Edit mode"]?.[language]}
          </p>
          <p>
            {
              dict?.[
                "Cannot select column, go back and create a new style if you want to select another column"
              ]?.[language]
            }
          </p>
        </>
      ) : (
        <>
          <section>
            <input
              className="margin_bottom"
              name="search_query"
              value={search_query}
              onChange={on_change}
              onFocus={on_reset_field}
            />
            <div>
              <button
                className="button background_black"
                onClick={on_reset}
                data-mapid="clickReset"
              >
                X Reset
              </button>
            </div>
          </section>
          {search_result}
        </>
      )}
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  properties: state.properties,
});

export default connect(mapStateToProps, { set_value_properties })(
  EDIT_LAYER_STYLE_1,
);
